import { render, staticRenderFns } from "./EbpfBasedTracing.vue?vue&type=template&id=50d39e86&scoped=true"
import script from "./EbpfBasedTracing.vue?vue&type=script&lang=js"
export * from "./EbpfBasedTracing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d39e86",
  null
  
)

export default component.exports